import React from "react";
import { LoadingLogo } from "./loading-logo";

export const LoadingPage: FC<React.ComponentProps<typeof LoadingLogo>> = (
  props,
) => (
  <LoadingLogo
    style={{ paddingTop: "15vh", marginInline: "auto" }}
    {...props}
  />
);
